import CELL_DATA_TYPES from '../cell-types.config';

// Content channel rulesets module configurations
const LISTING_COLUMNS = [
  {
    id: 'title',
    label: 'Channel Name',
    width: '40%',
    align: 'left',
    dataKey: 'title',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'assignmentRules',
    label: 'Assignment Rules',
    width: '20%',
    align: 'center',
    dataKey: 'assignmentRules',
    sortable: false,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'schedulingRules',
    label: 'Scheduling Rules',
    width: '20%',
    align: 'center',
    dataKey: 'schedulingRules',
    sortable: false,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'heroPlaylistSchedulingRules',
    label: 'Hero Playlist Scheduling Rules',
    width: '20%',
    align: 'center',
    dataKey: 'heroPlaylistSchedulingRules',
    sortable: false,
    type: CELL_DATA_TYPES.NUMBER,
  },
];

export default LISTING_COLUMNS;
